import { createRouter, createWebHistory } from 'vue-router'
import { updateSEO, generateWebsiteStructuredData, addStructuredData } from '@/utils/seo'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '首页',
      description: '为知实验室 - 交互式科学概念可视化平台，通过参数调节和实时可视化帮助用户理解基础科学原理。'
    }
  },
  {
    path: '/toy/:id(.*)',
    name: 'toy',
    component: () => import('../views/ToyDetail.vue'),
    meta: {
      title: '科学玩具详情',
      description: '交互式科学概念可视化演示'
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/Search.vue'),
    meta: {
      title: '搜索',
      description: '搜索科学可视化玩具'
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/Feedback.vue'),
    meta: {
      title: '反馈',
      description: '为知实验室用户反馈'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// SEO 导航守卫
router.beforeEach((to, from, next) => {
  // 更新基础 SEO 信息
  const meta = to.meta || {}
  updateSEO({
    title: meta.title,
    description: meta.description,
    keywords: meta.keywords,
    url: window.location.origin + to.fullPath
  })

  // 添加网站结构化数据（仅在首页）
  if (to.name === 'home') {
    addStructuredData(generateWebsiteStructuredData())
  }

  next()
})

export default router
